import { Box } from "@chakra-ui/react";
import React from "react";

import type { AddressSignedAuthorization } from "types/api/address";

import AddressAuthorizationsListItem from "./AddressAuthorizationsListItem";

interface Props {
  data: Array<AddressSignedAuthorization> | undefined;
  isLoading?: boolean;
}

const AddressAuthorizationsList = ({ data, isLoading }: Props) => {
  return (
    <Box>
      {data?.map((item, index) => (
        <AddressAuthorizationsListItem
          key={`${item.nonce}-${index}`}
          {...item}
          isLoading={isLoading}
        />
      ))}
    </Box>
  );
};

export default AddressAuthorizationsList;
